<template>
  <div class="device-row">
    <div style="flex: 1;">
      {{ auth.mac_address }}
    </div>
    <div style="flex: 1 1 10%;word-break: break-word;">
      {{ auth.name }}
    </div>
    <div style="flex: 1; word-break: break-word;">
      {{ auth.product.description }}
    </div>
    <div
        style="flex: 1; text-align: right;"
        :class="hidden">
      <el-tag>{{ auth.role | capitalize }}</el-tag>
      <span
          v-acl.show="{permission: 'manageSharedUser', on: 'Device'}"
          style="margin-left: 5px; color: white">
        <el-button
            v-if="!granted"
            :disabled="auth.role === 'owner'"
            type="primary"
            :loading="loading"
            size="small"
            @click="addUserToLocation(auth)">
          <i
              class="el-icon-plus"
              style="color:white"></i>
        </el-button>
        <el-button
            v-else
            :disabled="auth.role === 'owner'"
            type="danger"
            :loading="loading"
            size="small"
            @click="removeUserFromLocation(auth)">
          <i
              class="el-icon-minus"
              style="color:white"></i>
        </el-button>
      </span>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers as h } from "vuex";
import { get } from "lodash";
const { mapActions: locationActions } = h("db/account/location");

export default {
  name: "DeviceUserRow",
  props: {
    auth: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      granted: null,
      loading: false,
    };
  },
  computed: {
    isShareable() {
      const deviceType = get(this.auth, "type", "");
      return !deviceType.match("chime|base_station");
    },
    hidden() {
      if (this.isShareable) {
        return "";
      }

      return "hidden";
    },
  },
  created() {
    this.granted = this.auth.granted;
  },
  methods: {
    ...locationActions(["addUser", "removeUser"]),
    addUserToLocation(authorization) {
      this.loading = true;
      this.addUser(authorization)
        .then((response) => {
          this.loading = false;
          this.granted = true;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error);
        });
    },
    removeUserFromLocation(authorization) {
      this.loading = true;
      let auth = {
        location_id: authorization.location_id,
        doorbot_id: authorization.doorbot_id,
        user_id: authorization.user_id,
      };
      this.removeUser(auth)
        .then((response) => {
          this.loading = false;
          this.granted = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error);
        });
    },
  },
};
</script>

<style scoped>
.device-row {
  border-bottom: dashed 1px #f1f1f1;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 5px;
}
.device-row:last-child {
  border-bottom: none;
}

.success {
  color: #67c23a;
}
.error {
  color: #f56c6c;
}

.hidden {
  visibility: hidden;
}
</style>
